import { useEffect, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import PageTitle from "../../../../components/PageTitle";
import api from "../../../../services/api";
import TwoButtonsModal from "../../../../shared/Bootstrap/TwoButtonsModal";
import Spinner from "../../../../shared/Spinner/Spinner";
import { Installment, PaymentOption } from "../EnterprisePaymentOptions";
import Style from "./PaymentOptionsPageStyle"

export default function PaymentOptionPage(props) {
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const [name, setName] = useState("");
  const [installments, setInstallments] = useState<Installment[]>([])
  const [dates, setDates] = useState<number[]>([])
  const monthDays = Array.from(Array(31).keys());
  const [installmentToDelete, setInstallmentToDelete] = useState<number>();

  useEffect(() => {
    LoadInfo()
  }, [])

  function GoToInstallment(id: number) {
    const enterpriseId = props.match.params.enterpriseId;
    const paymentOptionId = props.match.params.paymentOptionId;
    props.history.push(`/enterprises/${enterpriseId}/paymentOptions/${paymentOptionId}/installment/${id}`);
  }

  async function LoadInfo() {
    try {
      const paymentOption: PaymentOption[] = await api.get(`/enterprises/${props.match.params.enterpriseId}/paymentOption`).then(result => result.data.paymentOptions);
      const data = paymentOption.find(obj => {
        return obj.id === parseInt(props.match.params.paymentOptionId);
      });
      setDates(data?.paymentDates.map(value => value.date) || [])
      setName(data?.name || "");
      setInstallments(data?.installments || []);
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  }

  async function DeleteInstallment() {
    setLoading(true)
    try {
      const id = installmentToDelete
      await api.delete(`/enterprises/${props.match.params.enterpriseId}/installment`, { data: { id } });
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setShowPopup(false);
      LoadInfo()
    }
  }

  function ConfirmInstallmentDeletion(id: number) {
    setInstallmentToDelete(id);
    setShowPopup(true);
  }

  async function UpdatePaymentOption() {
    const id = parseInt(props.match.params.paymentOptionId);
    return await api.put(`/enterprises/${props.match.params.enterpriseId}/paymentOption`, { id, name })
  }

  async function UpdatePaymentDates() {
    const paymentOptionId = parseInt(props.match.params.paymentOptionId);
    return await api.put(`/enterprises/${props.match.params.enterpriseId}/paymentOption/dates`, { dates, paymentOptionId })
  }

  async function OnSubmit() {
    try {
      if (name === "") {
        return
      }
      await UpdatePaymentOption();
      await UpdatePaymentDates();
    }
    catch (error) {
      console.log(error);
    }
    finally {
      props.history.goBack()
    }
  }

  function AddDate(n: number) {
    const newDates = [...dates, n].sort((a, b) => a - b);
    setDates(newDates)
  }

  function RemoveDate(n: number) {
    const newDates = dates.filter(value => value !== n).sort((a, b) => a - b);
    setDates(newDates);
  }

  const closePopup = () => setShowPopup(false);

  return (
    <Style className="default-page">
      <PageTitle title="Editar opção de pagamento" />
      <TwoButtonsModal
        show={showPopup}
        onHide={closePopup}
        loading={loading}
        title="Deletar parcela"
        body="Pode ocorrer problemas caso exista pedidos com essa parcela. Você tem certeza que deseja deletar essa parcela?"
        secondaryText="Fechar"
        secondaryOnClick={closePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={DeleteInstallment}
        primaryDisabled={loading}
      />
      <div>
        <button onClick={() => props.history.goBack()} className="btn-secondary go-back">Voltar</button>
      </div>
      <Spinner spinning={loading} />
      <main className="default-main">
        <div className="panel">
          <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
            <h2>Edição de opção de pagamento</h2>
            <div>
              <label>Nome:</label>
              <input
                type="text"
                value={name}
                placeholder={"Opção de pagamento"}
                onChange={e => setName(e.target.value)}
              />
            </div>

            <div>
              <label>Dias de pagamento:</label>
              <div className="payment-dates">
                {monthDays.map((day, index) => {
                  return (
                    <button
                      key={index}
                      className={(dates.includes(day + 1) ? "btn-primary" : "btn-secondary") + " btn btn-date"}
                      onClick={() => dates.includes(day + 1) ? RemoveDate(day + 1) : AddDate(day + 1)}>
                      {day + 1}
                    </button>
                  )
                })}
              </div>
            </div>

            <button
              className="btn btn-success btn-lg mt-4"
              type="button"
              onClick={e => { e.preventDefault(); OnSubmit() }
              }>Alterar</button>
          </form>
        </div>

        <div className="panel">
          <div id="title">
            <h4>Parcelas</h4>
            <button className="btn btn-success" disabled={loading} onClick={() => GoToInstallment(0)}>Adicionar</button>
          </div>
          <table className="table table-striped table-bordered table-hover" id="productVariationsForm">
            <thead >
              <tr>
                <th>ID</th>
                <th>Parcelas</th>
                <th>Taxa de juros</th>
                <th>Data limíte</th>
                <th>Opção de pagamento</th>
                <th>Deletar</th>
              </tr>
            </thead>
            <tbody>
              {installments.length > 0 && installments.map(installment => {
                return (
                  <tr key={installment.id} className="clickable">
                    <td onClick={() => GoToInstallment(installment.id)}>{installment.id}</td>
                    <td onClick={() => GoToInstallment(installment.id)}>{installment.installment === 1 ? "À vista" : installment.installment}</td>
                    <td onClick={() => GoToInstallment(installment.id)}>{installment.interestRate}</td>
                    <td onClick={() => GoToInstallment(installment.id)}>{new Date(installment.maxDate).toLocaleString()}</td>
                    <td onClick={() => GoToInstallment(installment.id)}>{name}</td>
                    <td className="action">
                      <button
                        onClick={() => ConfirmInstallmentDeletion(installment.id)}
                        disabled={loading}
                      ><FaTrashAlt className="icon" /></button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </main>
    </Style>
  )
}
